import { useState } from "react";
import { toast } from "sonner";
import { FileXls, SpinnerGap } from "@phosphor-icons/react";
import api, { apiErrorMessage } from "@/lib/api";
import { Button } from "@/components/ui/button";

const iso = (v) => {
  if (!v) return null;
  if (typeof v === "string") return v.slice(0, 10);
  return `${v.getFullYear()}-${String(v.getMonth() + 1).padStart(2, "0")}-${String(v.getDate()).padStart(2, "0")}`;
};

// Downloads unaggregated employee × date × jobsite rows for the KPI range/filters captured at click time.
export function ExportRawDataButton({ start, end, employees, jobs }) {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    const s = iso(start), e = iso(end);
    if (!s || !e) { toast.info("Pick a KPI date range first."); return; }
    setBusy(true);
    try {
      const params = { start: s, end: e, ...(employees ? { employees: employees.join("|") } : {}), ...(jobs ? { jobs: jobs.join("|") } : {}) };
      const res = await api.get("/timesheet/export-raw", { params, responseType: "blob", timeout: 180000 });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Strata_Timesheet_Raw_Data_${s}_to_${e}.xlsx`;
      a.click();
      URL.revokeObjectURL(url);
      toast.success(`Exported ${res.headers["x-row-count"] ?? ""} raw rows`.replace("  ", " "));
    } catch (err) {
      let msg = apiErrorMessage(err, "Export failed");
      if (err?.response?.data instanceof Blob) { try { msg = JSON.parse(await err.response.data.text()).detail || msg; } catch { /* keep */ } }
      toast.error(msg);
    } finally { setBusy(false); }
  };
  return (
    <div className="flex flex-col items-stretch" data-testid="kpi-export-raw-wrap">
      <Button size="sm" onClick={run} disabled={busy} className="w-full bg-emerald-600 hover:bg-emerald-700 text-white" data-testid="kpi-export-raw-data"
        title="Download every underlying timesheet row (employee × date × jobsite) for the selected KPI range and filters">
        {busy ? <SpinnerGap size={14} className="mr-1.5 animate-spin" /> : <FileXls size={14} weight="bold" className="mr-1.5" />}
        {busy ? "Exporting…" : "Export Raw Data"}
      </Button>
      <span className="text-[10px] text-slate-500 mt-1 text-right leading-tight" data-testid="kpi-export-raw-caption">
        Export Raw Data button outputs all timesheet data for selected KPI filtered range.
      </span>
    </div>
  );
}
